import styled from 'styled-components'

export const ItemContainer = styled.li`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.font.dark};
  line-height: 26px;
  font-size: ${({ theme }) => theme.typography.fontSize.minor};
  text-align: left;
  padding: 7px 10px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.background.grey};
    color: ${({ theme }) => theme.colors.input.active};
    p#note {
      color: ${({ theme }) => theme.colors.font.dark};
    }
  }
  &:focus {
    box-shadow: none;
    border: none;
    outline: 2px solid ${({ theme }) => theme.colors.input.active};
    border-radius: 4px;
  }
`
export const Label = styled.div`
  line-height: 36px;
`

export const Note = styled.p`
  margin: 4px 0 0 0;
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  display: block;
`
